import classes from "./Login.module.css";
import LoginComponent from "../../../Components/Login/Login";
import firstImage from "../../../images/LoginCarousel/coffee.jpg";
import secondImage from "../../../images/LoginCarousel/pot.jpg";
import thirdImage from "../../../images/LoginCarousel/noteBook.jpg";
import forthImage from "../../../images/LoginCarousel/workTable.jpg";
import fifthImage from "../../../images/LoginCarousel/wallClock.jpg";
import validate from "../../../utils/validations/validateV2";
import { ReactComponent as FirstNameIcon } from "../../../images/icons/forms/firstNameIcon.svg";
import { ReactComponent as NationalCodeIcon } from "../../../images/icons/forms/nationalCodeIcon.svg";
import { ReactComponent as CellphoneIcon } from "../../../images/icons/forms/cellphoneIcon.svg";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import useHttpFetch from "../../../hooks/useHttpFetch";
import { useNavigate } from "react-router-dom";
import FNMAuthContext from "../../../store/FNMStore/FNM-auth-context";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
// import CustomDatePicker from "../../../../Components/UI/CustomDatePicker/CustomDatePicker";

const images = [
	{ id: "43asg543", src: firstImage },
	{ id: "djesag", src: secondImage },
	{ id: "hlg4", src: thirdImage },
	{ id: "jfd54gdv", src: forthImage },
	{ id: "jfdvvv54gdv", src: fifthImage },
];
const fieldsSchema = [
	{
		id: "jzxbawcbxx",
		// onBlur: blurHandler,
		label: "تلفن همراه",
		fieldName: "cellphone",
		type: "number",
		// onChange: changeHandler,
		labelIcon: <CellphoneIcon />,
		maxLength: 11,
		validationType: "cellphone",
	},
];
const validateLoginForm = (data, setFormValidity) => {
	// const firstNameVali = validate({ data: data.firstName, type: "mandatory" });
	// const lastNameVali = validate({ data: data.lastName, type: "mandatory" });
	// const nationalCodeVali = validate({ data: data.nationalCode, type: "nationalCode" });
	const cellphoneVali = validate({ data: data.cellphone, type: "cellphone" });

	setFormValidity({
		// firstName: { ...firstNameVali },
		// lastName: { ...lastNameVali },
		// nationalCode: { ...nationalCodeVali },
		cellphone: { ...cellphoneVali },
	});
	// const datasAreValid =
	//   firstNameVali.isValid && lastNameVali.isValid && nationalCodeVali.isValid && cellphoneVali.isValid;
	const datasAreValid = cellphoneVali.isValid;

	return datasAreValid;
};

const FNMLogin = () => {
	const { isLoading: formIsSending, sendRequest: sendLoginFetch } = useHttpFetch();
	const { isLoading: otpIsSending, sendRequest: sendOtpFetch } = useHttpFetch();
	const { isLoading: logoutIsSending, sendRequest: sendLogoutFetch } = useHttpFetch();
	const navigate = useNavigate();
	const { setClientAuthInfo } = useContext(FNMAuthContext);
	const [openLogoutModal, setOpenLogoutModal] = useState(false);

	const loginHandler = async ({
		setOtpIsMounted,
		setFormIsMounted,
		data,
		setData,
		setFormValidity,
		restartTimer,
	}) => {
		const formIsValid = validateLoginForm(data, setFormValidity);
		if (!formIsValid) {
			toast.error("ابتدا فیلد های اشتباه را تصحیح کنید");
		} else {
			const finalData = {
				...data,
				// cellphone: restartTimer ? data.cellphone : `+98${data.cellphone.slice(1)}`,
				cellphone: data.cellphone?.startsWith("09") ? `+98${data.cellphone.slice(1)}` : data.cellphone,
			};
			const fetchAttributes = {
				method: "POST",
				url: "mlmDataEntry/MlmDataEntryUserEnter",
				body: finalData,
				noMiddleUrl: true,
				port: "9092",
			};
			const response = await sendLoginFetch(fetchAttributes);
			const result = response.response;

			if (result?.message?.toString()?.toLowerCase()?.includes("you are now logged in")) {
				setOpenLogoutModal((ps) => !ps);
			} else {
				if (result?.message === "this user is not available") {
					toast.error("اطلاعات وارد شده اشتباه می باشد");
				} else if (result?.message === "usercode or password is wrong") {
					toast.error("یوزرنیم یا پسورد اشتباه می باشد");
				} else if (result?.message === "you are already logged in") {
					toast.success("شما لاگین می باشید");
					navigate("/form-network-marketer");
				} else if (result?.message === "you may not owner of this cellphone!") {
					toast.error("لطفاً شماره همراهی را وارد کنید که مالکیت آن به نام شما باشد.");
				} else if (result?.message?.includes(`"nationalCodeCellphoneOfPersonnelList" is null`)) {
					toast.error(
						"ممکن است که اطلاعات اولیه شما تاکنون ثبت نشده باشد؛ لطفاً برای پیگیری به واحد  اداری مراجعه فرمایید."
					);
				} else if (result?.message.length === 13 || result?.message.length === 11) {
					toast.success("کد تایید با موفقیت ارسال شد");
					// setData((ps) => ({ ...ps, cellphone: result?.message }));
					if (setOtpIsMounted) setOtpIsMounted((ps) => !ps);
					if (setFormIsMounted) setFormIsMounted((ps) => !ps);
					if (restartTimer) restartTimer();
				} else if (result?.resStatus === 403) {
					toast.error("اطلاعات وارد شده اشتباه می باشد");
				} else if (result?.message === "Too many requests") {
					return null;
				} else {
					toast.error("خطایی رخ داد");
				}
			}
		}
	};
	const otpHandler = async ({ otp, data }) => {
		// console.log("first line of otpHandler");
		const verifyReqOptions = {
			method: "POST",
			url: "mlmDataEntry/MlmDataEntryUserAuthenticate",
			body: {
				code: otp.toString(),
				// mobileNumber: data.cellphone,
				mobileNumber: `+98${data.cellphone.slice(1)}`,
			},
			noMiddleUrl: true,
			port: "9092",
		};
		const response = await sendOtpFetch(verifyReqOptions);
		if (response?.response?.message === "verification code is not valid. try again.") {
			toast.error("کد نامعتبر است");
		} else if (response.resIsOk) {
			if (response?.resIsOk && response?.resStatus == 200) {
				setClientAuthInfo((prv) => ({ ...prv, isLoggedIn: true }));
				// if (response.resStatus == 222) {
				// const authRes = await sendFetch(authenticateReqOptions);
				// if (authRes.resIsOk) {
				//   toast.success("logged in successfullys");
				//   navigate("/");
				// } else {
				//   toast.error("error ::: ", authRes);
				// }
				toast.success("با موفقیت وارد شدید :)");
				// console.log("before navigate");
				navigate(`/form-network-marketer`);
				// navigate(`/form-network-marketer/add`);
				// } else {
				// 	toast.success("با موفقیت وارد شدید :)");
				// 	console.log("before navigate");
				// 	navigate(
				// 		`/form-network-marketer/add`
				// 	);
				// 	console.log("after navigate");
				// }
			}
		} else {
			toast.error("خطایی رخ داد");
		}
	};
	const handleLogout = async () => {
		const verifyReqOptions = {
			method: "GET",
			url: `Logout`,
			body: null,
			noMiddleUrl: true,
			port: "9092"
		};
		const result = await sendLogoutFetch(verifyReqOptions);
		if (result.resIsOk) {
			setOpenLogoutModal(false);
		} else {
			toast.error("خطایی رخ داد");
		}
	};

	return (
		<>
			<LoginComponent
				images={images}
				// data={data}
				helperTxt="لطفا برای ورود به سیستم تلفن همراهی را وارد فرمایید که مالکیت آن متعلق به شخص شما باشد."
				fieldsSchema={fieldsSchema}
				// formValidity={formValidity}
				formIsSending={formIsSending}
				loginHandler={loginHandler}
				otpHandler={otpHandler}
				otpIsSending={otpIsSending}
			/>

			<Dialog open={openLogoutModal} onClose={() => setOpenLogoutModal(false)}>
				{/* <DialogTitle id="alert-dialog-title">{"Use Google's location service?"}</DialogTitle> */}
				<DialogContent dir="rtl">
					<DialogContentText id="alert-dialog-description">
						شما در سیستم فرایند های شرکت هستید برای خروج از آن سیستم خروج را بزنید
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleLogout} autoFocus>
						خروج
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default FNMLogin;
